 
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/qcTask';
import { actions } from './QCTaskComments.slice';
import { Resp, dispatch } from '../helpers';
import {
  AddCommentAction,
  QCTaskCommentsFetchAction,
} from './QCTaskComments.types';

export function* fetchQCTaskCommentsWorker(action: QCTaskCommentsFetchAction) {
  try {
    const response: Resp<typeof api.fetchQCTaskComments> = yield call(
      api.fetchQCTaskComments,
      action.payload.clinicalTrialId,
      action.payload.taskId
    );
    yield dispatch(actions.fetchQCTaskCommentsSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchQCTaskCommentsFailure(error as Error));
  }
}

export function* addCommentWorker(action: AddCommentAction) {
  try {
    const response: Resp<typeof api.addQCTaskComments> = yield call(
      api.addQCTaskComments,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.message
    );
    yield dispatch(actions.addCommentSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.addCommentFailure(error as Error));
  }
}

export function* QCTaskCommentsSaga() {
  yield takeLatest(actions.fetchQCTaskComments.type, fetchQCTaskCommentsWorker);
  yield takeLatest(actions.addComment.type, addCommentWorker);
}
